export default function isClientPending(client) {
  return !client.joinedAt;
}
